import { ReactNode, useEffect, useState } from 'react';

import { useTheme } from '@/theme';
import { isInsidersInstance } from '@/theme/vars';
import { useAppDispatch } from '@/state/store';
import { initialAuthFlow } from '@/state/features/auth';
import { IS_DISCORD_ACTIVITY } from '@/globals';

// AuthGate makes sure everyone is logged in, and if they are not it logs them in as a guest
export default function AutoAuthGate({ children }: { children: ReactNode }) {
    const dispatch = useAppDispatch();

    // Disable login for discord activity since discord uses it's own auth mechanism.
    const disable_login = IS_DISCORD_ACTIVITY;

    // Do not run if autoGuestMode is disabled or on /auth routes
    // const theme = useTheme();
    // const autoGuestModeEnabled = theme.metadata?.authConfig?.autoGuestMode || isInsidersInstance; // Insiders cannot access logged out page
    const autoGuestModeEnabled = true;
    const isOnAuthRoute = window.location.pathname.startsWith('/auth');
    const checkedDefault = isOnAuthRoute || !autoGuestModeEnabled;

    const [checked, setChecked] = useState(checkedDefault);

    // If true, render content even if logged out
    const alwaysAllowContentRendering = process.env.PUBLIC_USE_STATIC_DATA === 'true';

    useEffect(() => {
        if (disable_login) {
            setChecked(true);
            return;
        }
        (async () => {
            if (!checked) {
                try {
                    // TODO: in theory this auth gate should redirect users to the login page if required. but since we currently don't use this type of flow, we just log them in as a guest.
                    await dispatch(initialAuthFlow());
                    setChecked(true);
                } catch (e) {
                    console.error(e);
                    setChecked(true);
                }
            } else {
                setChecked(true);
            }
        })();
    }, []);

    return alwaysAllowContentRendering || checked ? <>{children}</> : null;
}
